"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SingleWaveDropTab } from "./SingleWaveDrop";
import { useLayout } from "@/components/brain/my-stream/layout/LayoutContext";
interface SingleWaveDropInfoContainerProps {
  readonly activeTab: SingleWaveDropTab;
  readonly children: React.ReactNode;
}
export const SingleWaveDropInfoContainer: React.FC<SingleWaveDropInfoContainerProps> = t0 => {
  const $ = _c(5);
  const {
    activeTab,
    children
  } = t0;
  useLayout();
  const t1 = `${activeTab === SingleWaveDropTab.INFO ? "tw-block" : "tw-hidden"} lg:tw-w-[32rem] xl:tw-w-[36rem] 2xl:tw-max-w-2xl 2xl:tw-w-full tw-h-full tw-pt-4 lg:tw-pt-6 lg:tw-border lg:tw-border-l-0 lg:tw-border-r-[3px] lg:tw-border-solid tw-border-iron-800 tw-border-y-0 tw-bg-iron-950 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 lg:[--tab-height:0px]`;
  let t2;
  if ($[0] !== children) {
    t2 = <div className="tw-min-h-full tw-relative tw-bg-iron-950">{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};